module.exports = __webpack_public_path__ + "media/assets/images/blog/just-in-time-mac-small-1c1f1eecc3b298a89f4aa96ae65cce1c.jpg";